import { useMutation } from '@apollo/client'
import { Form, Formik } from 'formik'
import { toast } from 'react-toastify'

import apolloClient from '../../graphql/apolloClient'
import { GATEWAY_GENERATE_MUTATION } from '../../graphql/gateways'
import { gatewayInput } from '../../helpers/gatewayPaymentType'
import { Gateway } from '../../types/gateway'
import GatewayBasicInfo from './GatewayBasicInfo'
import GatewayCredential from './GatewayCredential'
import { gatewaysFormValidationSchema } from './validations/gatewaysFormValidation'

const GATEWAY_INIT_VALUES: Gateway = {
  basicDetails: {
    entity: '',
    entityType: 'Provider',
    gatewayId: '',
    name: '',
    entityId: '',
    supportedCurrencies: [],
    description: '',
    entityCode: '',
    displayEntityCode: '',
    active: true,
    walletType: ''
  },
  credential: {
    credentialMode: '',
    gatewaysType: ''
  },
  credentialModeDetails: {
    apiKey: '',
    merchantId: '',
    password: '',
    terminalId: '',
    username: ''
  }
}

const GateWayMainForm = () => {
  const [gatewayOnSubmitFunction, { loading: loadingForSubmit }] = useMutation(
    GATEWAY_GENERATE_MUTATION
  )
  const handleSubmit = async (values: Gateway) => {
    try {
      const { data: response } = await gatewayOnSubmitFunction({
        variables: { input: gatewayInput(values) }
      })

      toast.success(response.generateGateway.message)
      apolloClient.cache.evict({
        fieldName: 'gateways'
      })
    } catch (error) {
      if (error instanceof Error) {
        toast.error(error.message)
      } else {
        toast.error('ERROR!')
      }
    }
  }

  return (
    <Formik
      enableReinitialize
      initialValues={GATEWAY_INIT_VALUES}
      onSubmit={handleSubmit}
      validationSchema={gatewaysFormValidationSchema}>
      {({
        values,
        setFieldValue,
        errors,
        touched,
        handleBlur,
        isSubmitting
      }) => {
        return (
          <Form>
            <GatewayBasicInfo
              values={values}
              setFieldValue={setFieldValue}
              errors={errors}
              touched={touched}
              handleBlur={handleBlur}
              isSubmitting={isSubmitting}
            />
            <GatewayCredential
              values={values}
              setFieldValue={setFieldValue}
              errors={errors}
              touched={touched}
              handleBlur={handleBlur}
              isSubmitting={isSubmitting}
              loadingForSubmit={loadingForSubmit}
            />
          </Form>
        )
      }}
    </Formik>
  )
}
export default GateWayMainForm
